// extracted by mini-css-extract-plugin
module.exports = {"concept-diagram":"index__concept-diagram___1K2Km","conceptDiagram":"index__concept-diagram___1K2Km","adaptive":"index__adaptive___3xSif"};